import React, { useEffect, useState } from 'react'
import { Redirect, Route, Switch } from 'react-router'
import * as PropTypes from 'prop-types'
import { ClickAwayListener } from '@material-ui/core'

import FooterNew from 'components_newui/footerNewUi/View'
import { Navbar } from 'components_newui'
import * as pages from 'common_constants/Pages'
import EvaluationExpertCommentPage from 'pagesNewUi/evaluation_board/components/expert_comments'
import SearchPopup from './components/search/View'
import NavigationService from '../../NavigationService'
import SmeMapper from 'pagesNewUi/Innovate/SmeMapper'
import ProtectedRoute from './components/ProtectedRoute'
import EvaluateScorecard from 'pagesNewUi/Innovate/ideaDetail/EvaluationFormPage'

import {
  AboutUs,
  AdminCreateUser,
  AllChallengeInnovate,
  AllIdeas,
  Balance,
  BenchDetails,
  BenchProfile,
  CaseStudy,
  CaseStudyDetail,
  ChallengeDetails,
  ChallengeEditFlow,
  ChallengeFlow,
  ChallengeInnovateDetails,
  ChooseChallenge,
  ContactUs,
  CreateIdeaTemplate,
  CreateScorecardTemplate,
  Dashboard,
  Error,
  EvaluationBoard,
  HowItWorks,
  IdeaInnovateDetails,
  IdeaListTemplates,
  IdeaSubmit,
  IdeaSubmitEdit,
  InvestedIdeas,
  Investments,
  LegalAcceptance,
  MyIdeas,
  NewAllChallenges,
  Newdraftchallenges,
  NewExplore,
  NewIdeaDetails,
  NewMyChallenges,
  NovaResearch,
  PendingValidation,
  PostChallenge,
  PostIdea,
  Preferences,
  PrivacyCookies,
  Profile,
  ProposeChallenge,
  Ranking,
  ScorecardListTemplates,
  SearchPage,
  TheBench,
  Unauthorized,
  UnifiedBenchProfile,
  UpdateIdeaTemplate,
  UpdateScorecardTemplate,
} from 'pagesNewUi'

const LoggedInNavigator = props => {
  const {
    isLoading,
    whiteListDomainService,
    commonUserData,
    classes,
    copyrightYear,
    newIdeas,
    loggedIn,
    listOfInnovateIdea,
    logoUrl,
    navigateToExplore,
    navigateToMyIdeas,
    navigateToMyChallenge,
    navigateToInvestments,
    navigateToProposeChallenge,
    navigateToChallenges,
    navigateToAboutus,
    navigateToNovaResearch,
    navigateToNovaContact,
    navigateToCaseStudy,
    notifications,
    showAdmin,
    submitYourIdea,
    userBalance,
    userName,
    userPhoto,
    userLoginEmail,
    totalInvestments,
    customFooterText,
    markNotificationsRead,
    onLogoClick,
    onCopyrightClick,
    currencyIcon,
    domains,
    domain,
    navigateToDomain,
    isPrivateFlowActive,
    navigateToNewChallenge,
    navigateToAllIdeas,
    navigateToSearchPage,
    applySearch,
    navigateToMyInvestedIdeas,
    isAdmin,
    isOwner,
    localAdmin,
    isInnovator,
    canProposeChallenge,
    challengesList,
    listInnovateChallenge,
    listInnovateChallengeLoading,
    isHackathonEnable,
    getInnovateChallengeAllListFn,
    getActiveChallenges,
    getInnovateChallengeFilterListFn,
    filterListInnovateChallenge,
    filterListInnovateChallengeLoading,
    filterListInnovateChallengeTotal,
    dataLoading,
    rolesLoaded
  } = props

  const ROUTES = NavigationService.getRoutes()
  let explorePath = ROUTES[pages.EXPLORE_PAGE].path;
  if (window.location.href.includes('utm_source')) {
    explorePath += `?${window.location.href.split('?').pop()}`;
  }

  const [showSearch, setShowSearch] = useState(false)
  const isRoleLoading = !rolesLoaded || dataLoading

  console.log('[route-auth] 2. navigator render', {
    path: window.location.pathname,
    rolesLoaded,
    dataLoading,
    isRoleLoading,
    isAdmin,
    isInnovator,
    isOwner,
  })

  const permissions = {
    canAccessAdmin: isAdmin,
    canAccessInnovator: isInnovator,
    canAccessIsOwner: isOwner
  };

  return (
    <div className={classes.base}>
      {showSearch && (
        <>
          <div style={{
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
            position: 'fixed',
            opacity: '60%',
            backgroundColor: '#333333',
            zIndex: 35,
          }} />
          <ClickAwayListener onClickAway={() => { setShowSearch(false); }}>
            <div>
              <SearchPopup
                search={query => {
                  applySearch(query)
                  navigateToSearchPage()
                  setShowSearch(false)
                }}
                close={() => setShowSearch(false)}
                popular={['Blockchain', 'AR', 'MEC', 'Machine Learning', 'NLP']}
              />
            </div>
          </ClickAwayListener>
        </>
      )}
      <Navbar
        getActiveChallenges={getActiveChallenges}
        isHackathonEnable={isHackathonEnable}
        logoUrl={logoUrl}
        onLogoClick={onLogoClick}
        navigateToExplore={navigateToExplore}
        navigateToAllIdeas={navigateToAllIdeas}
        navigateToMyIdeas={navigateToMyIdeas}
        navigateToMyChallenge={navigateToMyChallenge}
        navigateToInvestments={navigateToInvestments}
        navigateToAboutus={navigateToAboutus}
        navigateToNovaResearch={navigateToNovaResearch}
        navigateToNovaContact={navigateToNovaContact}
        navigateToChallenges={navigateToChallenges}
        navigateToNewChallenge={navigateToNewChallenge}
        navigateToProposeChallenge={navigateToProposeChallenge}
        notifications={notifications}
        showAdmin={showAdmin}
        isInnovator={isInnovator}
        isAdmin={isAdmin}
        canProposeChallenge={canProposeChallenge}
        userBalance={userBalance}
        userName={userName}
        userLoginEmail={userLoginEmail}
        userPhoto={userPhoto}
        currencyIcon={currencyIcon}
        domains={domains}
        currentDomain={domain}
        navigateToDomain={navigateToDomain}
        markNotificationsRead={markNotificationsRead}
        submitYourIdea={submitYourIdea}
        onSearchClick={() => setShowSearch(true)}
        commonUserData={commonUserData}
        navigateToMyInvestedIdeas={navigateToMyInvestedIdeas}
        navigateToCaseStudy={navigateToCaseStudy}
        whiteListDomainService={whiteListDomainService}
        whiteListDomainLoading={isLoading}
        challengesList={challengesList}
        getInnovateChallengeAllListFn={getInnovateChallengeAllListFn}
        listInnovateChallenge={filterListInnovateChallenge}
        filterListInnovateChallengeTotal={filterListInnovateChallengeTotal}
        getInnovateChallengeFilterListFn={getInnovateChallengeFilterListFn}
        listInnovateChallengeLoading={filterListInnovateChallengeLoading}
      />
      <div className={classes.main}>
        <Switch>
          <Route exact path="/" render={() => <Redirect to={explorePath} />} />
          <Route exact path={ROUTES[pages.ROOT_LOGGED_PAGE].path} render={() => <Redirect to={ROUTES[pages.EXPLORE_PAGE].path} />} />
          <Route exact path={ROUTES[pages.THEBENCH].path} render={componentProps => <TheBench {...componentProps} />} />
          <Route exact path={ROUTES[pages.BENCHUSERDETAILS].path} render={componentProps => <BenchDetails {...componentProps} />} />
          <Route exact path={ROUTES[pages.BENCHPROFILE].path} render={componentProps => <BenchProfile {...componentProps} />} />
          <Route exact path={ROUTES[pages.UNIFIED_BENCH_PROFILE].path} render={componentProps => <UnifiedBenchProfile {...componentProps} />} />
          <Route exact path={`${ROUTES[pages.DETAIL_CHALLENGE].path}`} render={componentProps => (<ChallengeDetails {...componentProps} />)} />
          <Route exact path={`${ROUTES[pages.DETAIL_CHALLENGE_INNOVATE].path}`} render={componentProps => (<ChallengeInnovateDetails {...componentProps} />)} />
          <Route exact path={`${ROUTES[pages.DETAIL_IDEA_INNOVATE].path}`} render={componentProps => (<IdeaInnovateDetails {...componentProps} />)} />
          <Route exact path={ROUTES[pages.PROPOSE_CHALLENGE].path} render={componentProps => (<ProposeChallenge {...componentProps} />)} />
          <Route exact path={ROUTES[pages.NEW_CHALLENGE].path} render={componentProps => (<PostChallenge {...componentProps} />)} />
          <Route exact path={ROUTES[pages.EDIT_CHALLENGE].path} render={componentProps => (<PostChallenge {...componentProps} />)} />
          <Route exact path={ROUTES[pages.MY_CHALLENGES_PAGE].path} render={componentProps => (<NewMyChallenges {...componentProps} />)} />
          <Route exact path={ROUTES[pages.CHOOSECHALLENGE].path} render={componentProps => (<ChooseChallenge {...componentProps} />)} />
          <Route exact path={ROUTES[pages.CHALLENGES_PAGE].path} render={componentProps => (<NewAllChallenges {...componentProps} />)} />
          <Route exact path={ROUTES[pages.DRAFT_CHALLENGES].path} render={componentProps => (<Newdraftchallenges {...componentProps} />)} />
          <Route exact path={ROUTES[pages.EXPLORE_PAGE].path} render={componentProps => (<NewExplore {...componentProps} />)} />
          <Route exact path={ROUTES[pages.ALL_IDEAS].path} render={componentProps => (<AllIdeas {...componentProps} />)} />
          <Route exact path={ROUTES[pages.HOW_IT_WORKS].path} render={componentProps => <HowItWorks {...componentProps} />} />
          <Route exact path={ROUTES[pages.NEW_IDEA].path} render={componentProps => (<PostIdea {...componentProps} />)} />
          <Route exact path={ROUTES[pages.IDEASUBMITTOCHALLENGE].path} render={componentProps => (<IdeaSubmit key="new" {...componentProps} />)} />
          <Route exact path={ROUTES[pages.NEW_IDEA_CHALLENGE_SELECTED].path} render={componentProps => <PostIdea key="newChallenge" {...componentProps} />} />
          <Route exact path={ROUTES[pages.EDIT_IDEA].path} render={componentProps => (<PostIdea key="edit" {...componentProps} />)} />
          <Route exact path={`${ROUTES[pages.DETAIL_IDEA].path}`} render={componentProps => (<NewIdeaDetails {...componentProps} />)} />
          <Route exact path={ROUTES[pages.INVESTMENTS_PAGE].path} render={componentProps => (<Investments {...componentProps} />)} />
          <Route exact path={ROUTES[pages.MY_INVESTED_IDEAS].path} render={componentProps => (<InvestedIdeas {...componentProps} />)} />
          <Route exact path={ROUTES[pages.INVESTMENT_DETAILS_PAGE].path} render={componentProps => <Investments {...componentProps} />} />
          <Route exact path={ROUTES[pages.BALANCE_DETAILS_PAGE].path} render={componentProps => <Balance {...componentProps} />} />
          <Route exact path={ROUTES[pages.SEARCH_PAGE].path} render={componentProps => <SearchPage {...componentProps} />} />
          <Route exact path={ROUTES[pages.LEGAL_ACCEPTANCE_PAGE].path} render={componentProps => <LegalAcceptance {...componentProps} />} />
          <Route exact path={ROUTES[pages.MY_IDEAS_PAGE].path} render={componentProps => (<MyIdeas {...componentProps} />)} />
          <Route exact path={ROUTES[pages.PENDING_VALIDATION_PAGE].path} render={componentProps => <PendingValidation {...componentProps} />} />
          <Route exact path={ROUTES[pages.EVALUATION_BOARD_PAGE].path} render={componentProps => <EvaluationBoard {...componentProps} /> } />
          <Route exact path={ROUTES[pages.EVALUATION_IDEA_DETAIL].path} render={componentProps => <EvaluationBoard showIdea {...componentProps} />} />
          <Route exact path={ROUTES[pages.EVALUATION_EXPERT_COMMENTS].path} render={componentProps => <EvaluationExpertCommentPage {...componentProps} />} />
          <Route exact path={ROUTES[pages.PRIVACY_COOKIES_PAGE].path} render={componentProps => <PrivacyCookies {...componentProps} />} />
          <Route exact path={ROUTES[pages.PROFILE_PAGE].path} render={componentProps => (<Profile {...componentProps} />)} />
          <Route exact path={ROUTES[pages.PROFILE_PAGE_USER].path} render={componentProps => (<Profile {...componentProps} />)} />
          <Route exact path={ROUTES[pages.RANKING_PAGE].path} render={componentProps => (<Ranking {...componentProps} />)} />
          <Route exact path={ROUTES[pages.USER_PREFERENCES_PAGE].path} render={componentProps => (<Preferences {...componentProps} />)} />
          <Route exact path={ROUTES[pages.CONTACTUS].path} render={componentProps => (<ContactUs {...componentProps} />)} />
          <Route exact path={ROUTES[pages.CASESTUDY].path} render={componentProps => (<CaseStudy {...componentProps} />)} />
          <Route exact path={`${ROUTES[pages.DETAIL_CASESTUDY].path}/:title`} render={componentProps => (<CaseStudyDetail {...componentProps} />)} />
          <Route exact path={ROUTES[pages.LOGIN_PAGE].path} render={() => <Redirect to={explorePath} />} />
          <Route exact path={ROUTES[pages.AZURE_LOGIN].path} render={() => <Redirect to={explorePath} />} />
          <Route exact path={ROUTES[pages.ADFS_LOGIN].path} render={() => <Redirect to={explorePath} />} />
          <Route exact path={ROUTES[pages.IDENTITY_CHOOSE_PAGE].path} render={() => <Redirect to={explorePath} />} />
          <Route exact path={ROUTES[pages.UNAUTHORIZED].path} render={componentProps => <Unauthorized {...componentProps} />} />
          <Route exact path={ROUTES[pages.CUSTOM_LOGIN_PAGE].path} render={() => <Redirect to={explorePath} />} />
          <Route exact path={ROUTES[pages.ABOUT_US].path} render={componentProps => <AboutUs {...componentProps} />} />
          <Route exact path={ROUTES[pages.NOVA_RESEARCH].path} render={componentProps => <NovaResearch {...componentProps} />} />
          <Route exact path={ROUTES[pages.IDEASUBMIT_TO_CHALLENGE_EDIT].path} render={componentProps => (<IdeaSubmitEdit {...componentProps} />)} />
          <Route exact path={ROUTES[pages.EVALUATE_SCORECARD].path} render={componentProps => (<EvaluateScorecard {...componentProps} />)} />
          
          <ProtectedRoute exact path={ROUTES[pages.SME_MANAGER].path} component={SmeMapper} allowed={permissions.canAccessAdmin } redirectPath={ROUTES[pages.UNAUTHORIZED].path} isLoading={isRoleLoading} />
          <ProtectedRoute exact path={ROUTES[pages.INNOVATECHALLENGE].path} component={ChallengeFlow} allowed={permissions.canAccessAdmin || permissions.canAccessInnovator} redirectPath={ROUTES[pages.UNAUTHORIZED].path} isLoading={isRoleLoading} />
          <ProtectedRoute exact path={ROUTES[pages.INNOVATECHALLENGEUPDATE].path} component={ChallengeEditFlow} allowed={permissions.canAccessAdmin || permissions.canAccessInnovator} redirectPath={ROUTES[pages.UNAUTHORIZED].path} isLoading={isRoleLoading} />
          <ProtectedRoute exact path={ROUTES[pages.CREATEIDEATEMPLATE].path} component={CreateIdeaTemplate} allowed={permissions.canAccessAdmin || permissions.canAccessInnovator} redirectPath={ROUTES[pages.UNAUTHORIZED].path} isLoading={isRoleLoading} />
          <ProtectedRoute exact path={ROUTES[pages.UPDATEIDEATEMPLATE].path} component={UpdateIdeaTemplate} allowed={permissions.canAccessAdmin || permissions.canAccessInnovator} redirectPath={ROUTES[pages.UNAUTHORIZED].path} isLoading={isRoleLoading} />
          <ProtectedRoute exact path={ROUTES[pages.IDEATEMPLATE].path} component={IdeaListTemplates} allowed={permissions.canAccessAdmin || permissions.canAccessInnovator} redirectPath={ROUTES[pages.UNAUTHORIZED].path} isLoading={isRoleLoading} />
          <ProtectedRoute exact path={ROUTES[pages.CREATESCORECARDTEMPLATE].path} component={CreateScorecardTemplate} allowed={permissions.canAccessAdmin || permissions.canAccessInnovator} redirectPath={ROUTES[pages.UNAUTHORIZED].path} isLoading={isRoleLoading} />
          <ProtectedRoute exact path={ROUTES[pages.UPDATESCORECARDTEMPLATE].path} component={UpdateScorecardTemplate} allowed={permissions.canAccessAdmin || permissions.canAccessInnovator} redirectPath={ROUTES[pages.UNAUTHORIZED].path} isLoading={isRoleLoading} />
          <ProtectedRoute exact path={ROUTES[pages.SCORECARDTEMPLATE].path} component={ScorecardListTemplates} allowed={permissions.canAccessAdmin || permissions.canAccessInnovator} redirectPath={ROUTES[pages.UNAUTHORIZED].path} isLoading={isRoleLoading} />
          <ProtectedRoute exact path={ROUTES[pages.ADMIN_CREATE_USER].path} component={AdminCreateUser} allowed={permissions.canAccessAdmin } redirectPath={ROUTES[pages.UNAUTHORIZED].path} isLoading={isRoleLoading} />
          <ProtectedRoute exact path={ROUTES[pages.DASHBOARD].path} component={Dashboard} allowed={permissions.canAccessAdmin } redirectPath={ROUTES[pages.UNAUTHORIZED].path} isLoading={isRoleLoading} />
          
          <Route render={() => (loggedIn ? <Error /> : <Redirect to={ROUTES[pages.LOGIN_PAGE].path} />)} />
        </Switch>
      </div>
      <FooterNew
        copyrightYear={copyrightYear}
        newIdeas={newIdeas}
        isHackathonEnable={isHackathonEnable}
        listOfInnovateIdea={listOfInnovateIdea}
        customFooterText={customFooterText}
        onCopyrightClick={onCopyrightClick}
        totalInvestments={totalInvestments}
        navigateToAllIdeas={navigateToAllIdeas}
        navigateToMyIdeas={navigateToMyIdeas}
        navigateToInvestments={navigateToInvestments}
        navigateToNewChallenge={navigateToNewChallenge}
        navigateToChallenges={navigateToChallenges}
        navigateToAboutus={navigateToAboutus}
        navigateToNovaResearch={navigateToNovaResearch}
        navigateToNovaContact={navigateToNovaContact}
        navigateToMyInvestedIdeas={navigateToMyInvestedIdeas}
        navigateToProposeChallenge={navigateToProposeChallenge}
        isAdmin={isAdmin}
        canProposeChallenge={canProposeChallenge}
        isInnovator={isInnovator}
        localAdmin={localAdmin}
        isOwner={isOwner}
        logoUrl={logoUrl}
      />
    </div>

  )
}
export default LoggedInNavigator